module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@3x-76183ecdfcde4b2e17a0e3fc807974e9.png";